import { Price } from 'api-bible-shared-lib/utils/types';

export type PriceLabel = {
  amount: string;
  unit: string;
};

export const getPlanPriceLabel = (prices: Price[] | undefined): PriceLabel => {
  if (!prices) {
    return { amount: '$0', unit: '' };
  }

  const basePrice = prices.find((price) => price.usage_type === 'licensed');
  const meteredPrice = prices.find((price) => price.usage_type === 'metered');

  if (basePrice) {
    return { amount: `$${basePrice.unit_amount / 100}${meteredPrice ? '+' : ''}`, unit: '/month' };
  }

  if (meteredPrice) {
    return { amount: `$${(meteredPrice.unit_amount / 100).toFixed(2)}`, unit: '/CPM' };
  }

  return { amount: '', unit: '' };
};
